import React from 'react';

import { DropdownMulti as BaseDropdownMulti, GroupBase, Props } from 'app/design-system/components/DropdownMulti';
import { useTranslation } from 'app/lang';

import dictionary from './Dropdown.dictionary.json';

// ---

function Multi<
  T,
  IsMulti extends boolean = true,
  Group extends GroupBase<T> = GroupBase<T>
>(props: Props<T, IsMulti, Group>): JSX.Element {
  const { t } = useTranslation();

  const noOptionsMessage = () => t(dictionary.noOptions);

  return (
    <BaseDropdownMulti<T, IsMulti, Group> {...props}
                                          noOptionsMessage={noOptionsMessage} />
  );
}

export default Multi;
export * from 'app/design-system/components/DropdownMulti';
